export const serviceCategories = [
  {
    id: 1,
    category: "House Help",
    description: "Professional home cleaning and maintenance services",
    services: [
      {
        id: 1,
        title: "Bathroom Cleaning",
        description: "Deep cleaning of bathrooms with sanitization and deodorization.",
        icon: "Sparkles",
        image: "https://customer-assets.emergentagent.com/job_instant-chef-2/artifacts/95cbd5sh_1.png"
      },
      {
        id: 2,
        title: "House Cleaning",
        description: "Complete house cleaning including all rooms and living spaces.",
        icon: "Home",
        image: "https://customer-assets.emergentagent.com/job_instant-chef-2/artifacts/wnxhw8tf_2.png"
      },
      {
        id: 3,
        title: "Dish Washing",
        description: "Professional dish washing and kitchen utensil cleaning service.",
        icon: "Droplets",
        image: "https://customer-assets.emergentagent.com/job_instant-chef-2/artifacts/izpic5yf_3.png"
      },
      {
        id: 4,
        title: "Packing and Unpacking",
        description: "Expert packing and unpacking services for moving or storage.",
        icon: "Package",
        image: "https://customer-assets.emergentagent.com/job_instant-chef-2/artifacts/llxhveg0_4.png"
      },
      {
        id: 5,
        title: "Laundry",
        description: "Complete laundry service including washing, drying, and folding.",
        icon: "ShirtIcon",
        image: "https://customer-assets.emergentagent.com/job_instant-chef-2/artifacts/w3ftedt8_5.png"
      },
      {
        id: 6,
        title: "Kitchen Prep",
        description: "Kitchen organization and meal preparation assistance.",
        icon: "CookingPot",
        image: "https://customer-assets.emergentagent.com/job_instant-chef-2/artifacts/v38bxht7_6.png"
      }
    ]
  },
  {
    id: 2,
    category: "Instant Cook",
    description: "Professional home cooking services for delicious meals",
    services: [
      {
        id: 7,
        title: "Instant Cooking",
        description: "Expert home cooks to prepare fresh, delicious meals at your doorstep.",
        icon: "ChefHat",
        image: "https://customer-assets.emergentagent.com/job_instant-chef-2/artifacts/ww2vra7k_7.png"
      }
    ]
  },
  {
    id: 3,
    category: "Instant Bike and Car Care",
    description: "Professional vehicle cleaning and detailing services",
    services: [
      {
        id: 8,
        title: "Daily Bike Cleaning",
        description: "Quick and efficient daily bike cleaning to keep it spotless.",
        icon: "Bike",
        image: "https://customer-assets.emergentagent.com/job_instant-chef-2/artifacts/hbflizdc_11.png"
      },
      {
        id: 9,
        title: "Daily Car Cleaning",
        description: "Regular car cleaning service for a fresh, clean ride every day.",
        icon: "Car",
        image: "https://customer-assets.emergentagent.com/job_instant-chef-2/artifacts/8ui3bxzr_10.png"
      },
      {
        id: 10,
        title: "Bike Foam Wash",
        description: "Premium foam wash with deep cleaning and shine for your bike.",
        icon: "Sparkles",
        image: "https://customer-assets.emergentagent.com/job_instant-chef-2/artifacts/wgycozqz_8.png"
      },
      {
        id: 11,
        title: "Car Foam Wash",
        description: "Professional foam wash with interior and exterior detailing.",
        icon: "Sparkles",
        image: "https://customer-assets.emergentagent.com/job_instant-chef-2/artifacts/bvx5p1la_9.png"
      }
    ]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Priya",
    role: "Working Professional",
    image: "https://firebasestorage.googleapis.com/v0/b/doorush-ff77c.firebasestorage.app/o/icon-7797704_1280.png?alt=media&token=25acdba2-deb1-439d-8d14-f98a10e9503c",
    rating: 5,
    text: "doorush saved my day! Got a cook in 20 minutes for an unexpected guest dinner. Absolutely amazing service!"
  },
  {
    id: 2,
    name: "Rahul",
    role: "Business Owner",
    image: "https://firebasestorage.googleapis.com/v0/b/doorush-ff77c.firebasestorage.app/o/icon-7797704_1280.png?alt=media&token=25acdba2-deb1-439d-8d14-f98a10e9503c",
    rating: 5,
    text: "The bike cleaning service is phenomenal. They came to my office and my bike looked brand new. Super convenient!"
  },
  {
    id: 3,
    name: "Anita",
    role: "Homemaker",
    image: "https://firebasestorage.googleapis.com/v0/b/doorush-ff77c.firebasestorage.app/o/icon-7797704_1280.png?alt=media&token=25acdba2-deb1-439d-8d14-f98a10e9503c",
    rating: 5,
    text: "Reliable and professional maid service. The app is so easy to use and help arrives quickly. Highly recommended!"
  },
  {
    id: 4,
    name: "Vikram",
    role: "Software Engineer",
    image: "https://firebasestorage.googleapis.com/v0/b/doorush-ff77c.firebasestorage.app/o/icon-7797704_1280.png?alt=media&token=25acdba2-deb1-439d-8d14-f98a10e9503c",
    rating: 5,
    text: "Car cleaning at my doorstep? Yes please! The service is top-notch and saves so much time. Worth every penny!"
  }
];

export const faqs = [
  {
    id: 1,
    question: "How quickly can I get help?",
    answer: "Our average response time is 15-30 minutes depending on your location and service type. For urgent requests, our instant services can arrive even faster during peak hours."
  },
  {
    id: 2,
    question: "Are your service providers verified?",
    answer: "Absolutely! All our maids, cooks, and cleaning professionals undergo thorough background verification, training, and regular quality checks to ensure your safety and satisfaction."
  },
  {
    id: 3,
    question: "What areas do you serve?",
    answer: "We currently operate in major cities across India. Download the app to check if we're available in your area. We're rapidly expanding to new locations!"
  },
  {
    id: 4,
    question: "How do I pay for services?",
    answer: "We accept all major payment methods including UPI, credit/debit cards, and digital wallets. Payment is seamless through the app with transparent pricing."
  },
  {
    id: 5,
    question: "Can I schedule services in advance?",
    answer: "Yes! While we specialize in instant services, you can also schedule services for a specific date and time that suits you. Perfect for planning ahead!"
  },
  {
    id: 6,
    question: "What if I'm not satisfied with the service?",
    answer: "Your satisfaction is our priority. If you're not happy, contact our support team immediately. We offer refunds and will ensure the issue is resolved promptly."
  }
];

export const features = [
  {
    id: 1,
    title: "Lightning Fast",
    description: "Help arrives in minutes, not hours. We value your time.",
    icon: "Zap"
  },
  {
    id: 2,
    title: "Verified Professionals",
    description: "All service providers are background checked and trained.",
    icon: "ShieldCheck"
  },
  {
    id: 3,
    title: "Easy Booking",
    description: "Simple app interface. Book in just 3 taps.",
    icon: "Smartphone"
  },
  {
    id: 4,
    title: "Affordable Pricing",
    description: "Transparent rates with no hidden charges.",
    icon: "BadgeDollarSign"
  },
  {
    id: 5,
    title: "24/7 Support",
    description: "Our customer support team is always here to help.",
    icon: "Headphones"
  },
  {
    id: 6,
    title: "Secure Payments",
    description: "Multiple payment options with bank-grade security.",
    icon: "Lock"
  }
];

export const howItWorks = [
  {
    id: 1,
    step: "01",
    title: "Choose Service",
    description: "Select from maid, cook, bike cleaning, or car cleaning services."
  },
  {
    id: 2,
    step: "02",
    title: "Confirm Booking",
    description: "Pick your preferred time and confirm. Instant or scheduled - your choice."
  },
  {
    id: 3,
    step: "03",
    title: "Get Help",
    description: "Sit back and relax. Our professional arrives and gets the job done."
  }
];
